import { ActivityLogDetailValue, FullObject } from '@/api';
import { FCT } from '@/i18n';
import { formatEditorString, parseOrganTitle } from '@/shared/util';

import { ACTIVITY_LOG_DEFAULT_VALUES } from './activity-log.constant';

export const generateTitle = (title: string, fullObject: FullObject | null = {}) => {
  const { reportFindings = [], template } = fullObject || {};

  let result = '';

  if (reportFindings.length) {
    result = `${parseOrganTitle(reportFindings?.[0]?.template?.organ || '')} > ${reportFindings?.[0]?.template?.condition} > ${reportFindings?.[0]?.template?.uuid} > `;
  } else if (template && Object.keys(template).length) {
    result = `${parseOrganTitle(template.organ || '')} > ${template.condition} > ${template.uuid} > `;
  }

  result += `${title}`;

  return result;
};

export const formatValue = (data: ActivityLogDetailValue) => {
  if (ACTIVITY_LOG_DEFAULT_VALUES[data as keyof typeof ACTIVITY_LOG_DEFAULT_VALUES]) {
    return ACTIVITY_LOG_DEFAULT_VALUES[data as keyof typeof ACTIVITY_LOG_DEFAULT_VALUES];
  }

  if (data === null) {
    return FCT.ACTIVITY_LOGS.EMPTY_FINDING_LABEL;
  }

  if (Array.isArray(data)) {
    return data.length ? data.join(', ') : FCT.ACTIVITY_LOGS.EMPTY_FINDING_LABEL;
  }

  return formatEditorString(String(data));
};

export const shouldRenderArrow = (
  currentValue: ActivityLogDetailValue,
  previousValue: ActivityLogDetailValue,
): boolean => {
  const isValidValue = (value: ActivityLogDetailValue) =>
    value !== null &&
    value !== undefined &&
    (typeof value === 'string' ? value.trim().length > 0 : true);

  return isValidValue(currentValue) && isValidValue(previousValue);
};
